import React, { useMemo } from 'react';
import cn from 'classnames';
import { PapiDeviation } from '@wix/da-types-papi';
import { useTranslation } from 'react-i18next';
import { BiEventType } from '@wix/da-shared-react/pkg/biLogger/constants';
import Journal from '@wix/da-shared-react/pkg/DeviationViews/Feed/Journal';
import { NullableDropdownItem } from '@wix/da-shared-react/pkg/Dropdown/types';
import {
  getDeviationResourceType,
  isDeviationTextEditable,
} from '@wix/da-shared-react/pkg/DeviationViews/_helpers';
import PinIcon from '@wix/da-shared-react/pkg/Icons/24x24/Pin';

import s from './JournalFeedThumb.scss';

export interface Props {
  item: PapiDeviation;
  className?: string;
  isCurrentUserProfileOwner?: boolean;
  isPinned?: boolean;
  onPin: () => {};
  onUnpin: () => {};
  onEdit: () => {};
}

const JournalFeedThumb: React.FC<Props> = ({
  item,
  className,
  isCurrentUserProfileOwner,
  isPinned,
  onPin,
  onUnpin,
  onEdit,
}) => {
  const { t } = useTranslation();

  // TODO: consolidate with:
  // - Sections/PostsSection__profile_posts_feed/_partials/PostsFeed/PostsFeed.tsx
  // - UserWidgets/_partials/FeedThumb/FeedThumb.tsx
  const extraActions: NullableDropdownItem[] = useMemo(
    () => [
      isCurrentUserProfileOwner && {
        label: isPinned
          ? t('widgets.post.unpinFromHome')
          : t('widgets.post.pinToHome'),
        onClick: isPinned ? onUnpin : onPin,
        biData: {
          evid: BiEventType.WATCH_MENU_ITEM_SELECTION,
          typeid: getDeviationResourceType(item),
          itemid: item.deviationId,
          sectionname: 'journals',
          menu_item: isPinned ? 'unpin_to_top' : 'pin_to_top',
        },
      },
      isCurrentUserProfileOwner &&
        isDeviationTextEditable(item) && {
          label: t('widgets.post.edit'),
          onClick: onEdit,
          biData: {
            evid: BiEventType.WATCH_MENU_ITEM_SELECTION,
            typeid: getDeviationResourceType(item),
            itemid: item.deviationId,
            sectionname: 'journals',
            menu_item: 'edit',
          },
        },
    ],
    [isCurrentUserProfileOwner, isPinned, item, onEdit, onPin, onUnpin, t]
  );

  return (
    <div className={cn(s['root'], className)}>
      {isCurrentUserProfileOwner && isPinned && (
        <PinIcon withPadding className={s['pinned-icon']} />
      )}
      <Journal deviation={item} extraActions={extraActions} withComments />
    </div>
  );
};
JournalFeedThumb.displayName = 'JournalFeedThumb';

export default JournalFeedThumb;
